<section class="page__header">
    <custom-app-bar
            [hasBackButton]="true"
            [title]="'create_delivery_point.title' | translate"
    ></custom-app-bar>
</section>
<section class="page__content">
    <custom-form-field
            type="number"
            [formGroup]="deliveryPointGroup"
            controlName="code"
            [label]="'create_delivery_point.code' | translate"
    ></custom-form-field>
    <custom-form-field
            [formGroup]="deliveryPointGroup"
            controlName="taxId"
            [label]="'create_delivery_point.tax_id' | translate"
    ></custom-form-field>
</section>
<section class="page__footer">
    <button
            customButton
            size="large"
            expand="full"
            (click)="createDeliveryPoint()"
            [disabled]="(isConfirmDeliveryPointButtonLoading$ | async) || !deliveryPointGroup.valid"
            [isLoading]="isConfirmDeliveryPointButtonLoading$ | async"
    >{{'create_delivery_point.confirm_delivery_point' | translate}}
    </button>
</section>
